import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import { LoadingContainer } from '@ff-it/ui';
import { useAuthState, auth } from 'services/auth';
import { SessionContext } from './context';

export function SessionProvider({ children }: { children: ReactNode }): ReactElement {
  const authState = useAuthState();
  const didInitialise = useRef(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (didInitialise.current) {
      return;
    }

    didInitialise.current = true;

    // Direct fetch for session check to avoid global 401 handler
    fetch('/api/v1/auth/session/', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(async (response) => {
        if (response.ok) {
          const userData = await response.json();
          auth.user = userData;
        }
        // 401 is expected for unauthenticated users, no action needed
      })
      .catch((error) => {
        setLoading(() => {
          throw error;
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LoadingContainer loading={loading}>
      {loading ? null : <SessionContext.Provider value={authState}>{children}</SessionContext.Provider>}
    </LoadingContainer>
  );
}
